import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';

import { AuthenticationModule } from 'projects/lib_authentication/src/public-api';

import { AuthenticationService } from 'projects/lib_authentication/src/lib/services/authentication.service';

import { UtilModule } from 'projects/lib_util/src/public-api';
import { ApplicationSettings, ConfigModule, JurisdictionSettingsService } from 'projects/lib_config/src/public-api';
import { MenusModule } from '@progress/kendo-angular-menu';
import { DialogsModule } from '@progress/kendo-angular-dialog';

import { AppComponent } from './app.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { LayoutComponent } from './components/layout/layout.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BackNavigationHeaderComponent } from './components/back-navigation-header/back-navigation-header.component';
import { CredentialService } from 'projects/app_company-structure/src/app/services/credential.service';
import { NoAccessComponent } from './components/no-access/no-access.component';

import { registerLocaleData } from '@angular/common';
import localeNlBe from '@angular/common/locales/nl-BE';

registerLocaleData(localeNlBe, 'nl-BE'); //configuring this in the Utils module since we wanna make sure that the locale is set for every possible microservice in the future,
                                         //this way we only have to import the UtilModule and it is done

import '@progress/kendo-angular-intl/locales/nl-BE/all';
import { NoAccessToFeatureComponent } from './components/no-access-to-feature/no-access-to-feature.component';
import { CodeReceiveComponent } from './components/code-receive/code-receive.component';
import { PrivacyStatementComponent } from './components/privacy-statement/privacy-statement.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { OssCopyrightComponent } from './components/oss-copyright/oss-copyright.component';
import { AlertBannerComponent } from './components/alert-banner/alert-banner.component';
import { HomePageCardComponent } from './components/home-page-card/home-page-card.component';
import { CookieNoticeComponent } from './components/cookie-notice/cookie-notice.component';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    LayoutComponent,
    BreadcrumbComponent,
    BackNavigationHeaderComponent,
    NoAccessComponent,
    NoAccessToFeatureComponent,
    CodeReceiveComponent,
    PrivacyStatementComponent,
    TermsOfUseComponent,
    OssCopyrightComponent,
    CookieNoticeComponent,
    AlertBannerComponent,
    HomePageCardComponent
  ],
  imports: [
    UtilModule,
    ConfigModule,
    MenusModule,
    DialogsModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    AuthenticationModule
  ],
  providers: [
    CredentialService,
    AuthenticationService,
    {
      provide: APP_INITIALIZER,
      deps: [JurisdictionSettingsService],
      useFactory: (provider: JurisdictionSettingsService) => () => provider.loadSettings(),
      multi: true
    },
     {
       provide: LOCALE_ID,
       deps: [ApplicationSettings],
       useFactory: (settingsService: ApplicationSettings) => settingsService.getLocale()
     }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
